var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAbsence48Line = function SvgIconAbsence48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7 10h-3.4v5h3.4v-5ZM15.966 11.525l-2.404 2.404 3.535 3.536 2.404-2.404-3.535-3.536ZM32.041 11.531l-3.535 3.536 2.404 2.404 3.536-3.536-2.405-2.404ZM38 21.3H10v3.4h2.3V38h3.4v-2.3h16.6V38h3.4V24.7H38v-3.4Zm-5.7 11H15.7v-7.6h16.6v7.6Z",
    fill: "current"
  })));
};
export default SvgIconAbsence48Line;